export default __webpack_public_path__ + "static/media/hotelui.c5c6d9db.gif";